// extracted by mini-css-extract-plugin
module.exports = {"table":"LessonProgressStatisticList_table__EN5t7"};